import { ActiveInactiveStatusEnum } from '../../../../shared/enums/active-inactive-status.enum';
import { FirmwareOverviewModel } from '../../../../shared/models/firmware-overview.model';
import {
  mapBrandDtoToBrandModel,
  mapModelDtoToModelEntity,
} from '../../../../shared/utils/mapping/mapping.util';
import { ItemLabelModel } from '../../../shared/components/dropdown/models/dropdown-props.model';
import {
  mapFileMetadataDtoToFileMetadataModel,
  mapPlatformDtoToPlatformModel,
} from '../../../shared/utils/mapping/mapping.utils';
import { AttendedECUDto } from '../../dtos/attended-ECU.dto';
import { BrandDto } from '../../dtos/brand.dto';
import { FirmwareOverviewDto } from '../../dtos/firmware-overview.dto';
import { FirmwareRequestDto } from '../../dtos/firmware-request.dto';
import { FirmwareResponseDto } from '../../dtos/firmware-response.dto';
import { FirmwareRequestModel } from '../../models/firmware-request-model';
import { FirmwareResponseModel } from '../../models/firmware-response.model';
import { ModelEntity } from '../../models/model-entity.model';

export function mapModelEntityToItemLabelModel(
  model: ModelEntity
): ItemLabelModel {
  return {
    id: model.id,
    label: model.name,
  };
}

export function mapBrandModelToItemLabelModel(
  brand: ModelEntity
): ItemLabelModel {
  return {
    id: brand.id,
    label: brand.name,
  };
}

export function mapAttendedECUToItemLabelModel({
  id,
  name,
}: AttendedECUDto): ItemLabelModel {
  return {
    id: id,
    label: name,
  };
}

export function mapBrandDtoToItemLabelModel({
  id,
  name,
}: BrandDto): ItemLabelModel {
  return {
    id,
    label: name,
  };
}

export function mapAttendedEcusDtoToAttendedEcuModel(
  attendedEcu: AttendedECUDto
): ModelEntity {
  return {
    id: attendedEcu.id,
    name: attendedEcu.name,
  };
}

export const mapFirmwareResponseDtoToFirmwareResponseModel = (
  firmwareDto: FirmwareResponseDto
): FirmwareResponseModel => ({
  id: firmwareDto.id,
  name: firmwareDto.name,
  brand: firmwareDto.brand,
  model: firmwareDto.model,
  updateDate: firmwareDto.updateDate,
  creationDate: firmwareDto.creationDate,
  ecu: firmwareDto.ecu,
  platform: mapPlatformDtoToPlatformModel(firmwareDto.platform),
  versionName: firmwareDto.versionName,
  versionCode: firmwareDto.versionCode,
  description: firmwareDto.description,
  status: firmwareDto.status,
  file: mapFileMetadataDtoToFileMetadataModel(firmwareDto.file),
});

export const mapFirmwareRequestModelToFirmwareRequestDto = (
  firmwareRequestModel: FirmwareRequestModel
): FirmwareRequestDto => ({
  modelId: firmwareRequestModel.modelId,
  ecuId: firmwareRequestModel.ecuId,
  name: firmwareRequestModel.name,
  versionName: firmwareRequestModel.versionName,
  versionCode: firmwareRequestModel.versionCode,
  platformId: firmwareRequestModel.platformId,
  description: firmwareRequestModel.description,
  fileId: firmwareRequestModel.fileId,
  status:
    ActiveInactiveStatusEnum[
      firmwareRequestModel.status as keyof typeof ActiveInactiveStatusEnum
    ].toString(),
});

export const mapFirmwareOverviewDtoToFirmwareOverviewModel = (
  firmwareOverviewDto: FirmwareOverviewDto
): FirmwareOverviewModel => ({
  id: firmwareOverviewDto.firmwareId,
  name: firmwareOverviewDto.name,
  model: mapModelDtoToModelEntity(firmwareOverviewDto.model),
  brand: mapBrandDtoToBrandModel(firmwareOverviewDto.brand),
  ecu: mapAttendedEcusDtoToAttendedEcuModel(firmwareOverviewDto.ecu),
  version: firmwareOverviewDto.version ? firmwareOverviewDto.version : '',
  platform: mapPlatformDtoToPlatformModel(firmwareOverviewDto.platform),
  status: firmwareOverviewDto.status,
  size: firmwareOverviewDto.releaseSizeInBytes
    ? firmwareOverviewDto.releaseSizeInBytes
    : 0,
});
